/* TIMELESS MOONLIGHT MELTS — "Checkout now" button.

   Replaces Shopify's dynamic checkout button (Buy with Shop Pay + the "More
   payment options" row), which is switched off in templates/product.json.

   Shopify's product form posts to /cart/add and has no native "straight to
   checkout" submit, so this adds to the cart over the AJAX API first and then
   sends the visitor to /checkout. Posting the whole form as FormData matters:
   it carries the selected variant AND any line item properties, so a burner's
   "Your 15 melts" selection survives the jump to checkout.

   The button mirrors the add-to-cart's disabled state, so a sold-out variant
   can't be bought through the side door.
*/
(function () {
  'use strict';

  function init() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    if (form.querySelector('.tmm-checkout-now')) return;

    var atc = form.querySelector('.product-form__submit')
           || form.querySelector('[name="add"]')
           || form.querySelector('button[type="submit"]');
    if (!atc) return;

    var host = atc.parentElement;
    if (!host) return;

    var row = document.createElement('div');
    row.className = 'tmm-buy-row';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tmm-checkout-now';
    btn.textContent = 'Checkout now';

    var err = document.createElement('span');
    err.className = 'tmm-buy-error';
    err.setAttribute('role', 'status');
    err.setAttribute('aria-live', 'polite');

    row.appendChild(btn);
    row.appendChild(err);
    host.appendChild(row);

    function syncDisabled() {
      btn.disabled = !!atc.disabled;
    }
    syncDisabled();
    new MutationObserver(syncDisabled).observe(atc, { attributes: true, attributeFilter: ['disabled', 'class'] });

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      err.textContent = '';
      btn.disabled = true;
      var label = btn.textContent;
      btn.textContent = 'One moment…';

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (r) {
          if (r.ok) return r.json();
          return r.json().then(function (e) {
            throw new Error((e && (e.description || e.message)) || 'Could not add to basket.');
          });
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function (e) {
          btn.disabled = false;
          btn.textContent = label;
          err.textContent = e.message || 'Something went wrong — please try again.';
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Milano re-renders the form on variant change in some layouts. */
  document.addEventListener('shopify:section:load', init);
})();
